var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-work-order"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.exportToWord}},[_vm._v("导出全部工单信息表")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }